import React, { useState, useEffect } from "react";

export const svg = `<svg width="48" height="48" viewbox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24.06" cy="28.693" r="5.979" fill="#3FBFDD"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M18.326 21.741c-3.12-3.31-9.122-11.477-8.172-17.673-1.488 2.788-3.943 8.41-2.85 12.59a46.42 46.42 0 0 0 .793 2.7c.431 1.343.587 1.828.442 3.57-1.473-1.599-4.418-5.605-4.418-8.836-1.315 2.677-2.946 10.12 1.045 18.48 3.975.65 12.618 3.735 15.392 10.88l1.853-5.606c-2.011-.617-6.214-3.012-6.936-7.648-.722-4.637 1.6-7.57 2.85-8.457Zm11.469 0c3.12-3.31 9.121-11.477 8.171-17.673 1.489 2.788 3.944 8.41 2.85 12.59a46.418 46.418 0 0 1-.792 2.7c-.432 1.343-.588 1.828-.443 3.57C41.054 21.33 44 17.324 44 14.093c1.314 2.677 2.945 10.12-1.045 18.48-3.975.65-12.618 3.735-15.393 10.88l-1.853-5.606c2.012-.617 6.214-3.012 6.936-7.648.723-4.637-1.599-7.57-2.85-8.457Z" fill="#F4C874"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
